export default {
    queries: {
        staleTime: 5 * 60 * 1000,
    }
};
